import PermissionsService from '../../services/permissions.service';
import * as userActions from '../actions/user.actions';

const permissionsMiddleware = store => next => action => {
  const result = next(action);

  if (action.type === userActions.fetchCurrentUserSuccess.toString()) {
    PermissionsService.clearCache();
  }

  return result;
};

export default permissionsMiddleware;
